import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FeedbackFormComponent } from './feedback-form.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FeedbackService } from './feedback.service';
import { FeedbackFormRoutingModule } from './feedback-form-routing.module';
import { TranslateAllModule } from '../core/translate-all/translate-all.module';
import { CoreModule } from '../core/core.module';


@NgModule({
  declarations: [FeedbackFormComponent],
  imports: [
    CommonModule,
    FeedbackFormRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    CoreModule,
    TranslateAllModule
  ],
  providers: [
    FeedbackService
  ]
})
export class FeedbackFormModule { }
